import EVImg from '@components/EVImg';
import { Block } from '@components/Layout';
import { FC, useState } from 'react';
import EmbeddedForm, { UserData } from './EmbeddedForm';
import {
  Container,
  DesktopHeader,
  GridContainer,
  Header,
  ImageWrapper,
  MarketReportDescriptionContainer,
  MarketReportName,
  Text,
  TopContainer,
} from './styles';

export interface LeadGenerationFormProps {
  header?: string;
  media?: { url: string; fileName: string };
  placeholderMedia: { url: string };
  name: string;
  bodyText: string;
  disclaimer: string;
  userData?: UserData;
  chimeId?: string;
  chimeType?: string;
  ownershipId?: string;
  ownershipScope?: string;
  welcomeEmail?: boolean;
  shopname?: string;
}

const LeadGenerationForm: FC<LeadGenerationFormProps> = ({
  header,
  media,
  placeholderMedia,
  name,
  bodyText,
  disclaimer,
  userData,
  chimeId = '0',
  chimeType = 'EV Global',
  ownershipId,
  ownershipScope,
  welcomeEmail,
  shopname,
}) => {
  const [formSuccess, setFormSuccess] = useState(false);

  const handleDownloadClick = () => {
    window.open(media?.url, '_blank');
  };

  if (media && media.url) {
    return (
      <Block backgroundInner={'secondaryBg'} fullOnMobile>
        <Container>
          <TopContainer>
            <MarketReportDescriptionContainer>
              <MarketReportName>{name}</MarketReportName>
              <DesktopHeader>
                {header && <Header>{header}</Header>}
                {bodyText && typeof bodyText === 'string' && <Text>{bodyText}</Text>}
              </DesktopHeader>
            </MarketReportDescriptionContainer>
          </TopContainer>
          <GridContainer>
            {placeholderMedia?.url && (
              <ImageWrapper>
                <EVImg
                  src={`https:${placeholderMedia?.url}`}
                  layout="responsive"
                  width={520}
                  height={660}
                />
              </ImageWrapper>
            )}
            <EmbeddedForm
              userData={userData}
              setFormSuccess={setFormSuccess}
              media={media}
              disclaimer={disclaimer}
              handleDownloadClick={handleDownloadClick}
              shopname={shopname}
              chimeId={chimeId}
              chimeType={chimeType}
              ownershipId={ownershipId}
              ownershipScope={ownershipScope}
              welcomeEmail={welcomeEmail}
            />
          </GridContainer>
        </Container>
      </Block>
    );
  }
};

export default LeadGenerationForm;
